import { Box, Grid, Grow, List, ListItem, ListItemText, Paper, Popper, Tooltip, Typography, useTheme } from "@mui/material";
import { JsonServiceClient } from "@servicestack/client";
import { FC, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { StagePlan, StagePlanGetPointsByStageIdSubStage, StagePlanGetSingleByStageIdSubStage, StagePlanPlotPoint, StagePlanPlotPointStatuses } from "../../api/dtos";
import lotComingSoon from "../../assets/img/stageplan/lot.comingsoon.png";
import lotDepositTaken from "../../assets/img/stageplan/lot.deposittaken.png";
import lotForSale from "../../assets/img/stageplan/lot.forsale.png";
import lotNew from "../../assets/img/stageplan/lot.new.png";
import lotOnHold from "../../assets/img/stageplan/lot.onhold.png";
import lotSold from "../../assets/img/stageplan/lot.sold.png";
import Image from "../../components/layout/Image";

interface IStagePlanViewProps { 
    imageUrl?: string
}

const StagePlanView: FC<IStagePlanViewProps> = () => {
    const theme = useTheme();

    const params = useSearchParams();
    const stageId = Number(params[0].get('id'));
    const subStageParam = params[0].get('SubStageId');
    const subStageId = subStageParam ? Number(subStageParam) : undefined;

    // const lotMetadata = useFormMetadata(FormDefinitions.Lot);

    const [fadeTimeout, setFadeTimeout] = useState<NodeJS.Timeout>();

    // const [selectedSubStage, setSelectedSubStage] = useState<SubStages | null>();
    // const {data: lookups} = useLookups(lotMetadata);
    
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);


    // const subStages = useMemo(() => {
    //     return lots?.reduce<SubStages[]>((subs, lot) => 
    //         lot.subStage && !subs.includes(lot.subStage) 
    //             ? [...subs, lot.subStage] 
    //             : subs,[]
    // )}, [lots]);

    // useEffect(() => {
    //     setSelectedSubStage(subStages && subStages.length > 0 ? subStages[0] : undefined);
    // }, [subStages])

    const [stagePlan, setStagePlan] = useState<StagePlan | undefined>();
    const [plotPoints, setPlotPoints] = useState<StagePlanPlotPoint[] | undefined>();

    useEffect(() => {
        const fetchData = async () => {
            const client = new JsonServiceClient();
            const stagePlanResult = await client.get(new StagePlanGetSingleByStageIdSubStage({stageId, subStage: subStageId}));
            const plotPointResult = await client.get(new StagePlanGetPointsByStageIdSubStage({stageId, subStage: subStageId}));;

            setStagePlan(stagePlanResult.stagePlan);
            setPlotPoints(plotPointResult.plotPoints);
        }

        fetchData();
    }, [setStagePlan, setPlotPoints]);

    // const lotsToUse = useMemo(() => {
    //     return lots?.filter(lot => lot.subStage == selectedSubStage);
    // }, [lots, selectedSubStage])

    const [selectedPoint, setSelectedPoint] = useState<StagePlanPlotPoint | null>(null);

    const [imgDomElement, setImgDomElement] = useState<HTMLImageElement | null>(null);

    const [imgDimensions, setImgDimensions] = useState<{x: number; y: number; } | undefined>();

    useEffect(() => {
        if(anchorEl) {
            window.clearTimeout(fadeTimeout);
        }
    }, [anchorEl])

    useEffect(() => {
        if (!imgDomElement) {
            setImgDimensions(undefined);
            return;
        }

        imgDomElement.onload = () => {
            setImgDimensions({ y: imgDomElement.naturalHeight, x: imgDomElement.naturalWidth });
        }

    }, [imgDomElement, setImgDimensions])


    const handlePointClick = (event: React.MouseEvent<HTMLDivElement>, _point: StagePlanPlotPoint) => {
        if(anchorEl == event.target) {
            setAnchorEl(null);
        }
        else {
            setAnchorEl(event.target as HTMLDivElement);
        }
        event.stopPropagation();
    }

    const plotDiameter = 2.5;
    const legendDiameter = 16;

    const legend = [
        {
            iconUrl: lotForSale,
            text: "For Sale"
        },
        {
            iconUrl: lotDepositTaken,
            text: "Deposit Taken"
        },
        {
            iconUrl: lotSold,
            text: "Sold"
        },
        {
            iconUrl: lotComingSoon,
            text: "Coming Soon"
        },
        {
            iconUrl: lotOnHold,
            text: "On Hold"
        },
    ]
    return (
        <>
            {
                // subStages &&
                // <Paper
                //     sx={{
                //         padding: theme.spacing(2),
                //         width: 200
                //     }}
                // >
                //     <TextField
                //         label="SubStage"
                //         fullWidth
                //         variant="outlined"
                //         disabled={subStages.length == 0}
                //         select
                //         value={selectedSubStage ?? ""}
                //         onChange={(event) => {
                //             setSelectedSubStage(Number(event.target.value))
                //         }}
                //     >
                //         {
                //             subStages?.map((subStage, index) => 
                //                 <MenuItem key={index} value={subStage}><ListItemText primary={GetFieldLookupItem(lookups, 'SubStage', subStage)?.value?.toString()}/></MenuItem>
                //             )
                //         }
                //     </TextField>
                // </Paper>
            }
            <Grid
                sx={{
                    mt: theme.spacing(2)
                }}
                container
            >
                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 8,
                        xl: 8
                    }}
                    sx={{
                        position: "relative",
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            width: "100%"
                        }}
                    > 
                        <Popper
                            open={anchorEl != null}
                            anchorEl={anchorEl}
                            sx={{
                                opacity: 0.9,
                                width: 200
                            }}
                            transition
                        >
                            {({TransitionProps}) => (
                                <Grow {...TransitionProps} timeout={350}>
                                    <Paper 
                                        sx={{
                                            padding: theme.spacing(1)
                                        }}
                                    >
                                        <List
                                            dense
                                        >
                                            <ListItem>
                                                <ListItemText 
                                                    primary={
                                                        `Lot: ${selectedPoint?.lotNumber}`
                                                    }
                                                />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText
                                                    primary={
                                                        `
                                                            Status: ${
                                                                selectedPoint?.status == StagePlanPlotPointStatuses.ForSale
                                                                ? 'For Sale'
                                                                :  selectedPoint?.status == StagePlanPlotPointStatuses.DepositTaken
                                                                ? 'Deposit Taken'
                                                                :  selectedPoint?.status == StagePlanPlotPointStatuses.ComingSoon
                                                                ? 'Coming Soon'
                                                                :  selectedPoint?.status == StagePlanPlotPointStatuses.OnHold
                                                                ? 'On Hold'
                                                                :  selectedPoint?.status == StagePlanPlotPointStatuses.Sold
                                                                ? 'Sold'
                                                                : 'Unknown'
                                                            }
                                                        `
                                                    }
                                                />
                                            </ListItem>
                                            {
                                                selectedPoint?.size && 
                                                <ListItem>
                                                    <ListItemText
                                                        disableTypography
                                                        primary={
                                                            <Typography variant="body2">
                                                                Size (m<sup>2</sup>): {
                                                                    selectedPoint?.size
                                                                }
                                                            </Typography>
                                                        }
                                                    />
                                                </ListItem>
                                            }
                                            {
                                                selectedPoint?.description &&
                                                <ListItem>
                                                    <ListItemText
                                                        primary={
                                                            selectedPoint?.description
                                                        }
                                                    />
                                                </ListItem>
                                            }
                                        </List>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                        <Image
                            src={stagePlan?.imageUrl}
                            //ref={imgRef}
                            ref={ref => setImgDomElement(ref)}
                            sx={{
                                position: "relative",
                                display: "block",
                                width: "100%"
                            }}
                            
                        />
                        {imgDimensions && imgDomElement && plotPoints?.map((point, i) => {
                            // const lot = lotsToUse?.filter(lot => lot.id == point.lotId)[0];
                            const xPercentage = (point!.x!*100.0/imgDimensions.x);
                            const yPercentage = (point!.y!*100.0/imgDimensions.y);
                            
                            let backgroundUrl = lotSold;
                            switch(point.status) {
                                case StagePlanPlotPointStatuses.ForSale:
                                    backgroundUrl = lotForSale;
                                    break;
                                case StagePlanPlotPointStatuses.OnHold:
                                    backgroundUrl = lotOnHold;
                                    break;
                                case StagePlanPlotPointStatuses.DepositTaken:
                                    backgroundUrl = lotDepositTaken;
                                    break;
                                case StagePlanPlotPointStatuses.ComingSoon:
                                    backgroundUrl = lotComingSoon;
                                    break;
                                case StagePlanPlotPointStatuses.Sold:
                                    backgroundUrl = lotSold;
                                    break;
                                default:
                                    backgroundUrl = lotNew;
                                    break;
                            }
                            return (
                            <Tooltip key={i+1}
                                title={
                                    anchorEl 
                                        ? "" 
                                        : point.lotNumber
                                        ? `Lot ${point.lotNumber}` 
                                        : "No lot"
                                }
                            >
                                <Box
                                    sx={{
                                        fontSize: "0.85rem",
                                        width: `${plotDiameter}%`, 
                                        height: `${plotDiameter}%`, 
                                        position: "absolute",
                                        left: `${xPercentage}%`,
                                        top: `${yPercentage}%`,
                                        borderRadius: plotDiameter/2,
                                        color: "white",
                                        backgroundImage: `url(${backgroundUrl})`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: `contain`,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        userSelect: "none",
                                        ":hover" : {
                                            cursor: "pointer"
                                        }
                                    }}
                                    onMouseEnter={(event) => {
                                        setAnchorEl(event.currentTarget);
                                        setSelectedPoint(point);
                                        if(fadeTimeout) clearTimeout(fadeTimeout);
                                    }}
                                    onMouseLeave={(_event) => {
                                        setAnchorEl(null);
                                        setFadeTimeout(
                                            setTimeout(() => {
                                                setSelectedPoint(null);
                                            }, 350)
                                        );
                                    }}
                                    onClick={(event) => handlePointClick(event, point)}
                                    key={i+1}
                                >
                                </Box>
                            </Tooltip>
                        )})}
                    </Box>
                </Grid>
                <Grid
                    sx={{
                        fontFamily: "Montserrat,helvetica,arial,sans-serif!important",
                        fontSize: "0.85em",
                        textRendering: "optimizeLegibility",
                        position: "absolute",
                        top: 0,
                        right:0,
                        padding: "5px",
                        width:  "9em",
                        backgroundColor: "white",
                        color:  "#58595b",

                        [`@media (min-width: ${stagePlan?.legendswapoverSize}px)`]: {
                            position: "absolute",
                        },

                        [`@media (max-width: ${stagePlan?.legendswapoverSize}px)`]: {
                            position: "initial",
                        }
                    }}
                >
                    {
                        legend.map((x, i) => (
                            <Box
                                sx={{
                                    display: "flex",
                                    // mb: 0.5,
                                    alignItems: "center"
                                }}
                                gap={2}
                            >
                                <Box
                                    sx={{
                                        fontSize: "0.85rem",
                                        width: "1em",
                                        height: legendDiameter, 
                                        borderRadius: legendDiameter/2,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        userSelect: "none",
                                        backgroundImage: `url(${x.iconUrl})`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: `contain`,
                                    }}
                                    key={i+1}
                                >
                                </Box>
                                <Typography variant="body2" sx={{fontSize: "0.85em"}}>{x.text}</Typography>
                            </Box>
                        ))
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default StagePlanView;